import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AssignPropertiesFieldNames } from '../../modules/enterprisePolicies/_shared/types';

interface PropertyGroupSelectFieldProps extends Partial<Omit<SelectFieldProps, 'options' | 'name' | 'label'>> {
    filteredPropertyGroupIds?: string[];
}

export const PropertyGroupSelectField = ({ filteredPropertyGroupIds, ...props }: PropertyGroupSelectFieldProps) => {
    const localizeText = useLocalizeText();
    const propertyGroupOptionsQuery = useRepositorySuspenseQuery(
        'portfolioEnterpriseGroups',
        'getAll',
        {
            pagination: { pageSize: 0, pageIndex: 0 },
        },
        {
            select: ({ data }) =>
                pipe(
                    data,
                    array.filterMap(({ id, name, propertyIds }) =>
                        filteredPropertyGroupIds?.includes(id)
                            ? option.none
                            : option.some(
                                  createOption({
                                      label: name,
                                      value: id,
                                      secondaryText: localizeText({
                                          textKey: TextKey.PropertiesNumber,
                                          substitutes: { count: propertyIds.length },
                                      }),
                                  })
                              )
                    )
                ),
        }
    );

    return (
        <SelectField
            name={AssignPropertiesFieldNames.PropertyGroups}
            label={lt('PropertyGroupPlural')}
            options={propertyGroupOptionsQuery.data}
            {...props}
        />
    );
};
